@if (showLoader) {
	<div class="ibk-pl">
		<spinner-container></spinner-container>
	</div>
}
<div class="ibk-page">
	<router-outlet></router-outlet>
</div>
